import beach from 'src/assets/icons/beach.svg';
import fire from 'src/assets/icons/fire.svg';
import landscape from 'src/assets/icons/landscape.svg';
import food from 'src/assets/icons/food.svg';
import leisure from 'src/assets/icons/leisure.svg';
import adventure from 'src/assets/icons/adventure.svg';
import wildlife from 'src/assets/icons/wildlife.svg';
import history from 'src/assets/icons/history.svg';
import culture from 'src/assets/icons/culture.svg';
import beachTag from 'src/assets/icons/beach-tag.svg';
import party from 'src/assets/icons/party.svg';
import { TripAPI } from 'src/services/tripApiService/types';
import { Colors } from 'src/theme';
export type Trip = Omit<TripAPI, 'labels'> & {
  labels: TripLabel[];
};

export enum TripLabel {
  MOSTPOPULAR,
  LIMITEDSPOTS,
}

export enum TripTag {
  ADVENTUROUS = 'Adventurous',
  LEISURELY = 'Leisurely',
  CULTURE = 'Culture',
  HISTORY = 'History',
  LANDSCAPE = 'Landscape',
  BEACH = 'Beach',
  WILDLIFE = 'Wildlife',
  FOOD = 'Food',
  PARTY = 'Party',
  WINTER = 'Winter',
}

export enum TripType {
  Beach = 'beach',
  City = 'city',
  Desert = 'desert',
  Jungle = 'jungle',
  Mountain = 'mountain',
  Snow = 'snow',
  BoatTrip = 'boat_trip',
  Canyoning = 'canyoning',
  CookingClass = 'cooking_class',
  Cycling = 'cycling',
  Glamping = 'glamping',
  Hiking = 'hiking',
  IslandHopping = 'island_hopping',
  LocalCulture = 'local_culture',
  Nightlife = 'nightlife',
  Tasting = 'tasting',
  WaterSports = 'water_sports',
  Wildlife = 'wildlife',
  WinterSports = 'winter_sports',
  Yoga = 'yoga',
}

export const TripLabelSpecs = {
  [TripLabel.MOSTPOPULAR]: {
    backgroundColor: '#ffe4dd',
    textColor: Colors.principal.black,
    label: 'most popular',
    icon: beach,
  },
  [TripLabel.LIMITEDSPOTS]: {
    backgroundColor: '#ccf5e3',
    textColor: Colors.principal.black,
    label: 'limited spots',
    icon: fire,
  },
};
export const TripTagSpecs = {
  [TripTag.ADVENTUROUS]: {
    tag: 'Adventurous',
    icon: adventure,
  },
  [TripTag.LEISURELY]: {
    tag: 'Leisure',
    icon: leisure,
  },
  [TripTag.CULTURE]: {
    tag: 'Culture',
    icon: culture,
  },
  [TripTag.HISTORY]: {
    tag: 'History',
    icon: history,
  },
  [TripTag.LANDSCAPE]: {
    tag: 'Landscape',
    icon: landscape,
  },
  [TripTag.BEACH]: {
    tag: 'Beach',
    icon: beachTag,
  },
  [TripTag.WILDLIFE]: {
    tag: 'Wildlife',
    icon: wildlife,
  },
  [TripTag.FOOD]: {
    tag: 'Food',
    icon: food,
  },
  [TripTag.PARTY]: {
    tag: 'Party',
    icon: party,
  },
  [TripTag.WINTER]: {
    tag: 'Winter',
    icon: '',
  },
};

export const ACCEPTED_CURRENCIES = [
  'gbp',
  'eur',
  'usd',
  'cad',
  'aud',
  'nzd',
  'hkd',
  'aed',
  'chf',
] as const;
export type AcceptedCurrency = (typeof ACCEPTED_CURRENCIES)[number];

export type TripHighlight = {
  title: string;
  picture: {
    desktop: string;
    mobile: string;
  };
};

export type TripVideo = {
  source: string;
  codec: string;
};

export const Trip_Tags: Record<string, TripTag[]> = {
  AB2: [TripTag.BEACH, TripTag.PARTY, TripTag.FOOD],
  AL1: [TripTag.BEACH, TripTag.LANDSCAPE, TripTag.LEISURELY],
  AM1: [TripTag.ADVENTUROUS, TripTag.CULTURE, TripTag.FOOD],
  AQ1: [TripTag.ADVENTUROUS, TripTag.LANDSCAPE, TripTag.WILDLIFE],
  AR1: [TripTag.ADVENTUROUS, TripTag.FOOD, TripTag.CULTURE],
  AU1: [TripTag.BEACH, TripTag.LANDSCAPE, TripTag.WILDLIFE],
  BO1: [TripTag.CULTURE, TripTag.LANDSCAPE, TripTag.FOOD],
  BR2: [TripTag.CULTURE, TripTag.WILDLIFE, TripTag.PARTY],
  BZ1: [TripTag.BEACH, TripTag.WILDLIFE, TripTag.HISTORY],
  CA1: [TripTag.ADVENTUROUS, TripTag.WILDLIFE, TripTag.LANDSCAPE],
  CL1: [TripTag.ADVENTUROUS, TripTag.FOOD, TripTag.LANDSCAPE],
  CO1: [TripTag.CULTURE, TripTag.FOOD, TripTag.PARTY],
  CO2: [TripTag.LEISURELY, TripTag.BEACH, TripTag.CULTURE],
  CR1: [TripTag.ADVENTUROUS, TripTag.WILDLIFE, TripTag.LANDSCAPE],
  CR2: [TripTag.LEISURELY, TripTag.BEACH, TripTag.WILDLIFE],
  CU1: [TripTag.CULTURE, TripTag.BEACH, TripTag.PARTY],
  EC1: [TripTag.ADVENTUROUS, TripTag.WILDLIFE, TripTag.BEACH],
  EG1: [TripTag.CULTURE, TripTag.HISTORY, TripTag.LEISURELY],
  ES2: [TripTag.CULTURE, TripTag.FOOD, TripTag.PARTY],
  FI1: [TripTag.LANDSCAPE, TripTag.FOOD, TripTag.WINTER],
  FI2: [TripTag.ADVENTUROUS, TripTag.LANDSCAPE, TripTag.WINTER],
  GE1: [TripTag.LANDSCAPE, TripTag.FOOD, TripTag.CULTURE],
  GR1: [TripTag.LEISURELY, TripTag.BEACH, TripTag.HISTORY],
  GR2: [TripTag.BEACH, TripTag.HISTORY, TripTag.CULTURE],
  GT1: [TripTag.CULTURE, TripTag.HISTORY, TripTag.LANDSCAPE],
  HR1: [TripTag.BEACH, TripTag.FOOD, TripTag.PARTY],
  ID1: [TripTag.BEACH, TripTag.FOOD, TripTag.CULTURE],
  ID2: [TripTag.LEISURELY, TripTag.CULTURE, TripTag.BEACH],
  IN1: [TripTag.CULTURE, TripTag.WILDLIFE, TripTag.HISTORY],
  IN2: [TripTag.LEISURELY, TripTag.CULTURE, TripTag.BEACH],
  IN3: [TripTag.CULTURE, TripTag.HISTORY, TripTag.WILDLIFE],
  IS1: [TripTag.ADVENTUROUS, TripTag.LANDSCAPE, TripTag.WINTER],
  IS2: [TripTag.ADVENTUROUS, TripTag.LANDSCAPE, TripTag.WILDLIFE],
  IT3: [TripTag.CULTURE, TripTag.HISTORY, TripTag.FOOD],
  IT4: [TripTag.LEISURELY, TripTag.HISTORY, TripTag.FOOD],
  IT5: [TripTag.BEACH, TripTag.LANDSCAPE, TripTag.FOOD],
  JO1: [TripTag.ADVENTUROUS, TripTag.HISTORY, TripTag.CULTURE],
  JP2: [TripTag.CULTURE, TripTag.FOOD, TripTag.HISTORY],
  KE1: [TripTag.WILDLIFE, TripTag.LANDSCAPE, TripTag.CULTURE],
  KH1: [TripTag.LEISURELY, TripTag.HISTORY, TripTag.CULTURE],
  KR1: [TripTag.CULTURE, TripTag.FOOD, TripTag.BEACH],
  LK1: [TripTag.CULTURE, TripTag.BEACH, TripTag.WILDLIFE],
  MA2: [TripTag.CULTURE, TripTag.HISTORY, TripTag.LANDSCAPE],
  MA3: [TripTag.LEISURELY, TripTag.CULTURE, TripTag.LANDSCAPE],
  MA4: [TripTag.CULTURE, TripTag.HISTORY, TripTag.LANDSCAPE],
  MX2: [TripTag.CULTURE, TripTag.HISTORY, TripTag.FOOD],
  MX3: [TripTag.BEACH, TripTag.HISTORY, TripTag.WILDLIFE],
  MX4: [TripTag.CULTURE, TripTag.FOOD, TripTag.LANDSCAPE],
  MY1: [TripTag.WILDLIFE, TripTag.LANDSCAPE, TripTag.CULTURE],
  NO1: [TripTag.ADVENTUROUS, TripTag.LANDSCAPE, TripTag.FOOD],
  NZ1: [TripTag.ADVENTUROUS, TripTag.LANDSCAPE, TripTag.WILDLIFE],
  PE1: [TripTag.ADVENTUROUS, TripTag.WILDLIFE, TripTag.CULTURE],
  PH1: [TripTag.LEISURELY, TripTag.BEACH, TripTag.PARTY],
  PR1: [TripTag.BEACH, TripTag.CULTURE, TripTag.PARTY],
  PT1: [TripTag.FOOD, TripTag.BEACH, TripTag.PARTY],
  PT2: [TripTag.LANDSCAPE, TripTag.CULTURE, TripTag.WILDLIFE],
  RW1: [TripTag.WILDLIFE, TripTag.CULTURE, TripTag.LANDSCAPE],
  SC1: [TripTag.ADVENTUROUS, TripTag.LANDSCAPE, TripTag.FOOD],
  TH1: [TripTag.BEACH, TripTag.LANDSCAPE, TripTag.PARTY],
  TH2: [TripTag.LEISURELY, TripTag.BEACH, TripTag.CULTURE],
  TL1: [TripTag.LEISURELY, TripTag.CULTURE, TripTag.FOOD],
  TR1: [TripTag.HISTORY, TripTag.FOOD, TripTag.LANDSCAPE],
  TR2: [TripTag.CULTURE, TripTag.FOOD, TripTag.HISTORY],
  TZ1: [TripTag.LEISURELY, TripTag.WILDLIFE, TripTag.LANDSCAPE],
  TZ2: [TripTag.WILDLIFE, TripTag.CULTURE, TripTag.LANDSCAPE],
  VC1: [TripTag.CULTURE, TripTag.HISTORY, TripTag.FOOD],
  VN1: [TripTag.LEISURELY, TripTag.FOOD, TripTag.CULTURE],
  ZA1: [TripTag.ADVENTUROUS, TripTag.WILDLIFE, TripTag.LANDSCAPE],
};

export const TripTagsKey = (key: string) => {
  return TripTag[key as keyof typeof TripTag];
};

export const getGalleryImages = (trip: Omit<Trip, 'labels'>) =>
  trip.pictures.length > 1 ? trip.pictures.slice(1) : trip.pictures;

export enum ProductLineSlug {
  FLASH_PACK = 'flash_pack',
  AGE_45_59 = 'age_45_59',
}

export type ProductLine = {
  slug: ProductLineSlug;
  value: string;
};
